<i class="arrow-icon"
  [ngClass]="direction"
  [ngStyle]="{
    'border-color': colorName ? (colorName | color) : color,
    'padding': size
    }">
</i>
